/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const RegistrySource = {
  Byo: "byo",
  Serving: "serving",
  Cluster: "cluster",
} as const;
export type RegistrySource = ClosedEnum<typeof RegistrySource>;

/** @internal */
export const RegistrySource$inboundSchema: z.ZodNativeEnum<
  typeof RegistrySource
> = z.nativeEnum(RegistrySource);
/** @internal */
export const RegistrySource$outboundSchema: z.ZodNativeEnum<
  typeof RegistrySource
> = RegistrySource$inboundSchema;
